export default __webpack_public_path__ + "static/sketch2-4d0cfe7bcc7956cc65b41b95f1b82068.jpg";